import ProductSliderDesktop from './ProductSliderDesktop';

export default ProductSliderDesktop;
export type { ProductSliderDesktopProps } from './ProductSliderDesktop';
export { productSliderFitsStaticGrid } from './ProductSliderStaticGrid';
